module.exports = __webpack_public_path__ + "img/saoma.10468cf0.png";